// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
(function () {
  var params = new URLSearchParams(window.location.search);
  var raw = params.get('pin');
  if (!raw) return;

  var pins = raw.split(',').map(function (h) {
    return decodeURIComponent(h.trim()).toLowerCase().replace(/^\/+|\/+$/g, '');
  }).filter(Boolean);
  if (!pins.length) return;

  var pinPage = parseInt(params.get('pin_page') || '1', 10) || 1;
  var currentPage = parseInt(params.get('page') || '1', 10) || 1;
  var shouldInject = currentPage === pinPage;
  var injected = false;

  function productHandleFromHref(href) {
    if (!href) return '';
    var path = href.split('?')[0].split('#')[0];
    var i = path.indexOf('/products/');
    if (i === -1) return '';
    return path.slice(i + 10).replace(/\/$/, '').toLowerCase();
  }

  function cardOf(node) {
    return node.closest('.product-item, .product-card, .grid__item, li, article');
  }

  function gridEl() {
    return document.querySelector(
      '.product-grid, [data-product-grid], .collection__products, ul.products, .products'
    );
  }

  function hideOriginals() {
    var grid = gridEl();
    if (!grid) return;
    grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('[data-pin-injected="true"]')) return;
      var handle = productHandleFromHref(a.getAttribute('href'));
      if (pins.indexOf(handle) === -1) return;
      var card = cardOf(a);
      if (card) card.style.display = 'none';
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format || '{{amount}}');
    }
    var n = (Number(cents) / 100).toFixed(2);
    return n;
  }

  function rewriteCard(clone, product) {
    clone.setAttribute('data-pin-injected', 'true');
    clone.setAttribute('data-product-handle', product.handle);
    clone.style.display = '';

    var url = '/products/' + product.handle;

    clone.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.setAttribute('href', url);
    });

    var img = product.featured_image;
    if (img) {
      clone.querySelectorAll('img').forEach(function (image, idx) {
        if (idx > 1) return;
        image.setAttribute('src', img);
        image.setAttribute('alt', product.title || '');
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
      });
    }

    var title = clone.querySelector(
      '.product-item__product-title, .product-title, .product-item__title, h3, h2, .card__heading'
    );
    if (title) title.textContent = product.title;

    var priceEl = clone.querySelector('.product-item__price, .price, .product-price');
    if (priceEl && product.price != null) {
      priceEl.textContent = formatMoney(product.price);
    }

    return clone;
  }

  function sampleCard() {
    var grid = gridEl();
    if (!grid) return null;
    return grid.querySelector('.product-item, .product-card, .grid__item, li, article');
  }

  function fallbackCard(product) {
    var url = '/products/' + product.handle;
    var wrap = document.createElement('article');
    wrap.className = 'product-item';
    wrap.setAttribute('data-pin-injected', 'true');
    wrap.innerHTML =
      '<a href="' + url + '">' +
        (product.featured_image ? '<img src="' + product.featured_image + '" alt="">' : '') +
        '<h3 class="product-item__product-title">' + product.title + '</h3>' +
        '<div class="product-item__price">' + formatMoney(product.price) + '</div>' +
      '</a>';
    return wrap;
  }

  function inject(products) {
    var grid = gridEl();
    if (!grid || injected) return;
    var sample = sampleCard();
    var parent = sample ? sample.parentElement : grid;

    for (var i = products.length - 1; i >= 0; i--) {
      var p = products[i];
      if (!p) continue;
      var node = sample ? rewriteCard(sample.cloneNode(true), p) : fallbackCard(p);
      parent.insertBefore(node, parent.firstElementChild);
    }
    injected = true;
    hideOriginals();
  }

  function run() {
    hideOriginals();
    if (!shouldInject || injected) return;

    Promise.all(
      pins.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (list) {
      inject(list.filter(Boolean));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    injected = false;
    run();
  });

  var grid = gridEl();
  if (grid && window.MutationObserver) {
    new MutationObserver(function () {
      hideOriginals();
    }).observe(grid, { childList: true, subtree: true });
  }
})();